module.exports = __webpack_public_path__ + "static/media/header-1.fc762856.jpg";